import reverse from "lodash/reverse";
import sortBy from "lodash/sortBy";

import type { Invoice } from "./TaxInvoices.types";

type TaxInvoicesState = {
  invoices?: {
    invoiceYears?: { data?: { invoice_years?: number[] } };
    invoicesByYear?: {
      data?: { invoice_count?: number; invoices?: Invoice[] };
      isFetching?: boolean;
    };
  };
};

/** Stable references so `useSelector` doesn't re-render on every store update. */
const EMPTY_YEARS: number[] = [];
const EMPTY_INVOICES: Invoice[] = [];

/** Years the guest has invoices for, newest first. */
const selectInvoiceYearsSorted = (state: TaxInvoicesState) => {
  const years = state.invoices?.invoiceYears?.data?.invoice_years;
  return years?.length ? reverse(sortBy(years)) : EMPTY_YEARS;
};

const selectLatestInvoiceYear = (state: TaxInvoicesState) =>
  String(selectInvoiceYearsSorted(state)[0] ?? "");

const selectInvoices = (state: TaxInvoicesState) =>
  state.invoices?.invoicesByYear?.data?.invoices ?? EMPTY_INVOICES;

const selectInvoiceCount = (state: TaxInvoicesState) =>
  state.invoices?.invoicesByYear?.data?.invoice_count ?? 0;

const selectInvoicesAreFetching = (state: TaxInvoicesState) =>
  Boolean(state.invoices?.invoicesByYear?.isFetching);

export {
  selectInvoiceCount,
  selectInvoices,
  selectInvoicesAreFetching,
  selectInvoiceYearsSorted,
  selectLatestInvoiceYear,
};
export type { TaxInvoicesState };
